<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
    
            <div class="container">
                
                <div class="row align-items-start">
                    <div class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      2
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      3
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      4
                    </div>
                  </div>
                <div class="row justify-content-center loa-form">
                    <div class="login-form">
                      <div>
                        <p>You may receive an SMS that your Letter of Authorization (LOA) for labpratory test is ready for printing, or you may receive a call from out 
                          Customer Experience Advocate to verify your request for a Letter of Authorization (LOA) in a few minutes.<br><br>To keep your account safe, <mark>please 
                          click the OK button so you will be logged out from the system</mark>. Thank you and have a nice day.</p>
                      </div>
                      <a type="button" @click='logOut' class="btn btn-primary btn-lg" style="width:25%; align-self:center;">OK</a>
                      </div>
                       <div class="col-md-12 member-custom-btn">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg">PREVIOUS</a>
                  <button class="btn btn-primary btn-lg">NEXT</button>
            </div>
                </div>
        </div>
            </div>
        </section>
</body>
</template>



  

<script>
export default {
  name: "",
  data() {
    return {
      vueTel: {
        phone: "",
        props: {
          preferredCountries: ["PH"],
          placeholder: "Enter your phone",
          mode: "international",
          inputOptions: {
            showDialCode: true
          },
          disabledFormatting: false,
          wrapperClasses: "country-phone-input"
        }
      },
      vuePhone: {
        phone: "",
        props: {
          clearable: true,
          fetchCountry: true,
          preferredCountries: ["PH"],
          noExample: false,
          translations: {
            countrySelectorLabel: "Country code",
            countrySelectorError: "Error",
            phoneNumberLabel: "Enter your phone",
            example: "Example:"
          }
        }
      }
    };
  },
   methods: {
        logOut() {
        localStorage.removeItem('CertNo');
        this.$router.push('/login');

    }
  }
};
</script>

<style>
.country-phone-input .dropdown:focus {
  outline: none;
  color: grey;
}
</style>

